import type { RefObject } from 'react';

// Generic check for whether a mouse event originated outside a given ref's element.
export const isEventOutsideRef = (event: MouseEvent, ref: RefObject<HTMLElement | null>) =>
  !ref.current?.contains(event.target as Node);
